<div class="row mb-4">
  <div class="col-sm-7">
    <ng-template transloco let-t>
      <span class="{{titleClass}}"> {{ likes && likes.length ? t('SOCIAL.LIKED_BY') : t('FEEDBACK.LET_US_KNOW_HOW_WE_ARE_DOING') }} </span>
    </ng-template>
  </div>
  <div class="col-sm-5 text-center">
    <button
      mdbBtn type="button" color="primary" mdbWavesEffect rounded="true"
      (click)="toggle()"
      [disabled]="loading"
      >
      <i class="fa-solid fa-{{liked ? 'heart-crack':'heart'}}"></i>
      <!-- <mdb-icon fas icon="{{liked ? 'heart-broken':'heart'}}" class="mr-1"></mdb-icon> -->
      <span *transloco="let t">{{ liked ? t('SOCIAL.UNLIKE') : t('SOCIAL.LIKE') }}</span>
    </button>
  </div>
</div>
@for (like of likes; track like; let i = $index) {
  <div class="chip" style="cursor: default;">
    @if (!maxLikesDefaultView || (maxLikesDefaultView && i < maxLikesDefaultView)) {
      <img
        [src]="like | userAvatar" [alt]="like.fname+' '+like.lname">
        }{{like.fname+' '+like.lname}}
      </div>
    }
    @if (maxLikesDefaultView && likes && likes.length > maxLikesDefaultView) {
      <div>
        ... and {{likes.length - maxLikesDefaultView}} more
      </div>
    }